import { HistoryLogDto } from "./HistoryLogDto";
import { FileDto } from "../common/interfaces/FileDto";
import { NotaryPreviewDto } from "./NotaryPreviewDto";
import { PageDto } from "../common/interfaces/PageDto";
import { RegisterType } from "../common/interfaces/enums/RegisterType";
import { OwnerDto } from "./OwnerDto";

export enum CertificationTZMode {
  Signature = "signature",
  Content = "content",
  Both = "both",
}

export type CertificationProps = {
  registerType: RegisterType;
};

type CertificationBase = {
  certificationId?: number;
  registerType?: RegisterType;
  certificationTZMode?: CertificationTZMode;
  registrationNumberSignature?: number;
  issueDateSignature?: Date;
  registrationNumberContent?: number;
  issueDateContent?: Date;
  participants?: string;
  statement?: string;
} & OwnerDto;

export type CertificationInputDto = {
  userId: number;
  fileId?: number;
  correctionReason?: string;
  version?: string;
} & CertificationBase;

export type CertificationPreviewDto = {
  notary: NotaryPreviewDto;
  file: FileDto;
  historyLogs: HistoryLogDto[];
  createDate: Date;
} & CertificationBase;

export type CertificationSearchDto = {
  registerType: RegisterType;
  notaryId?: number;
  registrationNumber?: number;
  issueDate?: Date;
  keywords?: string;
  participants: boolean;
  statement: boolean;
} & PageDto;

export type CertificationSearchResultDto = {
  certificationId: number;
  registrationNumberSignature?: number;
  issueDateSignature?: Date;
  registrationNumberContent?: number;
  issueDateContent?: Date;
  notary: NotaryPreviewDto;
  participants: string;
  statement: string;
} & OwnerDto;

export type CertificationHistoryPreviewDto = {
  correctionReason?: string;
} & CertificationPreviewDto;
